/* eslint-disable */ 
export default {
  methods: {
    handleSizeChange(val) {
      this.form.pageSize = val
      this.query()
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val
      this.query()
    },
    async query(query) {
      if (query) {
        this.form.pageIndex = 1
      }
      try {
        let { result }= await this.queryFunction(this.form)
        this.tableData = result.result || []
        this.total = result.pagination && result.pagination.numberRecords || 0
      } catch (err) {
        this.tableData = []
        this.total = 0
      }  
    },
    async exportList() {
      try {
        let { result } = await this.exportFunction(this.form)
        window.location.href = eval("'" + result.uri + "'") 
      } catch (e) {
        console.log(e)
      }
      
    }
  }
} 